import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import type { GeoInfo } from "../../types/common.type";

const initialState:GeoInfo = {
    ipAddress:'',
    showCityPopup:false,
    isForceShow:false,
    isLoading:false,
    pincode:null,
    city:{
        cityId:null,
        cityName:null
    },
    state:{
        stateId:null,
        stateName:null
    }
} 

const pincodeSlice = createSlice({
    name:'pincode_store',
    initialState,
    reducers:{


        setIsPincodeLoading:(state, action:PayloadAction<boolean>)=>{
          state.isLoading = action.payload
        },

        setShowCityPopup:(state, action:PayloadAction<boolean>)=>{
            state.showCityPopup = action.payload
        
        },

        setIsForceShow:(state, action:PayloadAction<boolean>) => {
            state.isForceShow = action.payload
        },


        setGeoInfo:(state, action:PayloadAction<GeoInfo>)=> {
            state.ipAddress = action.payload.ipAddress;
            state.pincode = action.payload.pincode ;
            state.city.cityId = action.payload.city.cityId;
            state.city.cityName = action.payload.city.cityName
            state.state.stateId = action.payload.state.stateId
            state.state.stateName = action.payload.state.stateName
            state.isLoading = action.payload.isLoading
             state.showCityPopup = action.payload.showCityPopup;
            state.isForceShow = action.payload.isForceShow;
        },

        clearGeoInfo: (state) => {
      state.ipAddress = "";
      state.pincode = "";
      state.city = { cityId: null, cityName: "" };
      state.state = { stateId: null, stateName: "" };
      state.isLoading = false;
      state.showCityPopup = false;
      state.isForceShow = false;
    }
    }
})


export const selectGeo = (root:RootState) => root.geoInof
export const selectIsPincodeLoading = (root:RootState) => root.geoInof.isLoading 
export const selectShowCityPopup = (root:RootState)=>root.geoInof.showCityPopup
export const {setGeoInfo, setIsPincodeLoading, setShowCityPopup,clearGeoInfo, setIsForceShow} = pincodeSlice.actions;
export default pincodeSlice.reducer;